import { useEffect } from 'react'
import { useRouter, useSearch } from '@tanstack/react-router'

/**
 * Variable listener
 */
const useVariableListener = (
  value: any
): void => {

  const router = useRouter()
  const search = useSearch({
    strict: false
  })

  useEffect(() => {
    router.navigate({ search })
  }, [value, router, search])

}

export default useVariableListener
